<ion-item lines="none" class="ion-no-padding"
  [class.auto-pointer-evts]="lockIndicator == true"
  [title]="lockIndicator == true ? lockTitle : ''">
  <ion-label *ngIf="!hideLabel" position="stacked">
    <ion-icon *ngIf="lockIndicator" slot="start" [name]="(disabled) ? 'lock-closed-outline' : 'lock-open-outline'">
    </ion-icon>
    {{ label + (required ? '*' : '')  }}
  </ion-label>
  <ion-input type="text" [id]="id" [placeholder]="placeholder" [maxlength]="maxLength" [min]="min" [max]="max"
    [style.max-width]="maxWidth"
    [debounce]="debounce" class="ion-text-right" [disabled]="disabled" (ionChange)="onInputChange($event)"
    (ionBlur)="onBlur($event)" (ionFocus)="gotFocus()" [inputFocus]="focus" #numberInput>
  </ion-input>
</ion-item>
<p *ngIf="subLabel != null" class="sub-label">
  {{ subLabel }}
</p>